import { CSSProperties, useMemo } from 'react';

type WidgetPosition = {
  x: number,
  y: number,
  width: number,
  height: number,
};

const isSet = (value?: number | string | null) => {
  return !Number.isNaN(Number(value));
};

const useWidgetPointerStyle = (position?: WidgetPosition) => useMemo((): CSSProperties | undefined => {
  if (!position) {
    return undefined;
  }
  const {
    x, y, width, height,
  } = position;
  if (!isSet(x) || !isSet(y) || !isSet(width) || !isSet(height)) {
    return undefined;
  }
  return {
    position: 'absolute',
    left: `${x * 100}%`,
    top: `${y * 100}%`,
    width: `${width * 100}%`,
    height: `${height * 100}%`,
    cursor: 'pointer',
    pointerEvents: 'all',
  };
}, [position]);

export default useWidgetPointerStyle;
